/**
 * An icon from the one Vault sprite in `index.html` (60 symbols, stamped by
 * `scripts/build-sprite.mjs` from the design's mock-ups). Built node by node —
 * never a markup string. Decorative by default: the control carries the name.
 */
const NS = "http://www.w3.org/2000/svg";

export type IconId =
  | "i-alert" | "i-arrow-up" | "i-badge" | "i-bank" | "i-bell" | "i-card" | "i-chain"
  | "i-check" | "i-chev-d" | "i-chev-l" | "i-chev-r" | "i-chev-u" | "i-clock" | "i-copy" | "i-eye"
  | "i-eye-off" | "i-home" | "i-id" | "i-key" | "i-list" | "i-lock" | "i-mic" | "i-passkey"
  | "i-pause" | "i-phone" | "i-pie" | "i-plus" | "i-receipt" | "i-send" | "i-shield" | "i-speaker"
  | "i-spin" | "i-stop" | "i-token" | "i-trend" | "i-user" | "i-users" | "i-x"
  // Round E batch 1 (DCTA-92; in the sprite since DCTA-111 inc0)
  | "i-arrow-dn" | "i-calendar" | "i-cart" | "i-device" | "i-doc" | "i-download" | "i-globe" | "i-laptop"
  | "i-logout" | "i-mail" | "i-pencil" | "i-search" | "i-share" | "i-sliders" | "i-snow" | "i-trash" | "i-unlock" | "i-wave"
  // DCTA-169's edit in place (DCTA-170)
  | "i-minus" | "i-swap" | "i-undo"
  // DCTA-209: a payment that repeats (09-scheduled.md F64)
  | "i-repeat";

export function icon(id: IconId, cls?: string): SVGSVGElement {
  const svg = document.createElementNS(NS, "svg");
  if (cls !== undefined) svg.setAttribute("class", cls);
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  const use = document.createElementNS(NS, "use");
  use.setAttribute("href", `#${id}`);
  svg.appendChild(use);
  return svg;
}
